import { render } from "./PlanSalesContent.vue?vue&type=template&id=d73550ea"
import script from "./PlanSalesContent.vue?vue&type=script&lang=js"
export * from "./PlanSalesContent.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PlanSalesContent.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_d50d1876%2Fpackages%2Fbo%2Fsrc%2Fviews%2Fplan_sales%2Flist%2FPlanSalesContent.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__